"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChunkedUploadCompleteToJSON = exports.ChunkedUploadCompleteFromJSONTyped = exports.ChunkedUploadCompleteFromJSON = exports.instanceOfChunkedUploadComplete = void 0;
var AssetType_1 = require("./AssetType");
/**
 * Check if a given object implements the ChunkedUploadComplete interface.
 */
function instanceOfChunkedUploadComplete(value) {
    var isInstance = true;
    isInstance = isInstance && "uploadSessionId" in value;
    isInstance = isInstance && "numberOfSections" in value;
    isInstance = isInstance && "assetType" in value;
    return isInstance;
}
exports.instanceOfChunkedUploadComplete = instanceOfChunkedUploadComplete;
function ChunkedUploadCompleteFromJSON(json) {
    return ChunkedUploadCompleteFromJSONTyped(json, false);
}
exports.ChunkedUploadCompleteFromJSON = ChunkedUploadCompleteFromJSON;
function ChunkedUploadCompleteFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'uploadSessionId': json['upload_session_id'],
        'numberOfSections': json['number_of_sections'],
        'assetType': (0, AssetType_1.AssetTypeFromJSON)(json['asset_type']),
    };
}
exports.ChunkedUploadCompleteFromJSONTyped = ChunkedUploadCompleteFromJSONTyped;
function ChunkedUploadCompleteToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'upload_session_id': value.uploadSessionId,
        'number_of_sections': value.numberOfSections,
        'asset_type': (0, AssetType_1.AssetTypeToJSON)(value.assetType),
    };
}
exports.ChunkedUploadCompleteToJSON = ChunkedUploadCompleteToJSON;
